import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/sign-in");
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data);
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate("/dashboard");
      } catch (e) {
        navigate("/sign-in");
      }
    })();
  }, [navigate, setUser]);

  return (
    <main className="max-w-md mx-auto px-6 py-24 text-center">
      <div className="fleuron mb-6">❦</div>
      <p className="font-display italic text-2xl text-ink-iron">Striking the wax seal…</p>
    </main>
  );
}
